import { combineReducers, type ReducersMapObject } from '@reduxjs/toolkit';
import fuse from './fuse';
import i18n from './i18nSlice';
import user from './userSlice';
import notifications from './notifications';

const createReducer = (asyncReducers: ReducersMapObject) =>
	combineReducers({
		fuse,
		i18n,
		user,
		notifications,
		...asyncReducers
	});

export default createReducer;
